// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170546/js/" + chunkId + "." + {"44":"3e6fe44d","225":"a57002c3","481":"c74482c6","486":"7465b92b","770":"1d894589"}[chunkId] + ".0.718629046316854.chunk.js";
};